(ns hypnos.consumer.events
  "Events for the consumer application."
  (:require [hypnos.consumer.db :as db]
            [hypnos.translator.patient :as t-p]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; DB

(rf/reg-event-fx
 :consumer/noop
 (fn [{db :db} _]
   {:db (assoc-in db [:ui :loading?] false)}))

(rf/reg-event-fx
 :consumer/initialize-app
 (fn [{db :db} [_ subdomain]]
   {:db (merge db
               db/default-db
               {:subdomain subdomain})}))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; UI

(rf/reg-event-db
 :consumer/set-active-panel
 (fn [db [_ {:keys [name params]}]]
   (-> db
       (assoc-in [:ui :active-panel] {:name   name
                                      :params params}))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Consult

(rf/reg-event-db
 :consumer/set-consult
 (fn [db [_ {:keys [data _errors]}]]
   (let [attrs   (first (vals data))
         consult (t-p/patient-consult->clj attrs)]
     (assoc db :consult consult))))

(rf/reg-event-db
 :consumer/set-portrait-upload-status
 (fn [db [_ portrait-upload-status]]
   (assoc-in db [:portrait :upload-status] portrait-upload-status)))

(rf/reg-event-db
 :consumer/portrait-uploaded
 (fn [db [_ {:keys [data _errors]}]]
   (-> db
       (assoc-in [:portrait :upload-status] (when data :uploaded))
       (assoc-in [:portrait :issues] (or (:issues data) [])))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Errors

(rf/reg-event-db
 :consumer/set-error
 (fn [db [_ error]]
   (assoc db :error error)))
